import { ProfileI } from './../../interfaces/Profile';
import { 
  FriendState, 
  friendActions
} from './../types/friendTypes';
import { 
  GET_FRIENDS
} from '../constants/index';

const initialState: FriendState = {
  person: {} as ProfileI,
  friends: [],
  friendRequests: [],
  blacklist: [],
  archived: []
}

const friendReducer = (state = initialState, action: friendActions) => {
  const payload = action.payload;

  switch(action.type){

    case GET_FRIENDS:
      return {
        person: payload.person,
        friends: payload.friends,
        friendRequests: payload.friendRequests,
        blacklist: payload.blacklist,
        archived: payload.archived
      }
        
    default: 
      return state
  }
}

export default friendReducer;
